import { Countries } from 'shared/enums';
import { postData } from 'api/services/mediaPlanning/utils';
import { ApiResponse } from 'api/services/mediaPlanning/types';
import { CalculatedTVBudget } from 'store/planStore';
import { OFFLINE } from './setup';

export interface Copy {
  name: string;
  copyLength?: number;
  advertisers?: string[];
  advertisersLength?: number;
}

export interface GRPCopy {
  name: string;
  grp: number;
}

export interface GRP {
  year: number;
  month: number;
  weekNumber: number;
  copies: GRPCopy[];
}

export const getEstimatedTVBudget = async ({
  body,
}: {
  body: {
    copies?: Copy[];
    countryISO: string;
    grps?: GRP[];
    targetGroup: string;
  };
  countryISO?: Countries;
}) => {
  return postData<ApiResponse<CalculatedTVBudget>>(
    `/${OFFLINE}/calculate`,
    body
  );
};
